<template>
  <d-navbar-nav class="border-left flex-row">
    <!--    <li class="nav-item border-right dropdown notifications">-->
    <!--      <a class="nav-link nav-link-icon text-center" v-d-toggle.notifications>-->
    <!--        <div class="nav-link-icon__wrapper">-->
    <!--          <i class="material-icons">&#xE7F4;</i>-->
    <!--          <d-badge pill theme="danger">2</d-badge>-->
    <!--        </div>-->
    <!--      </a>-->
    <!--      <d-collapse id="notifications" class="dropdown-menu dropdown-menu-small">-->
    <!--        <d-dropdown-item>-->
    <!--          <div class="notification__icon-wrapper">-->
    <!--            <div class="notification__icon">-->
    <!--              <i class="material-icons">&#xE6E1;</i>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="notification__content">-->
    <!--            <span class="notification__category">Analytics</span>-->
    <!--            <p>Your website’s active users count increased by <span class="text-success text-semibold">28%</span> in the last week. Great job!</p>-->
    <!--          </div>-->
    <!--        </d-dropdown-item>-->
    <!--        <d-dropdown-item href="#">-->
    <!--          <div class="notification__icon-wrapper">-->
    <!--            <div class="notification__icon">-->
    <!--              <i class="material-icons">&#xE8D1;</i>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="notification__content">-->
    <!--            <span class="notification__category">Sales</span>-->
    <!--            <p>Last week your store’s sales count decreased by <span class="text-danger text-semibold">5.52%</span>. It could have been worse!</p>-->
    <!--          </div>-->
    <!--        </d-dropdown-item>-->
    <!--        <d-dropdown-item class="notification__all text-center">View all Notifications</d-dropdown-item>-->
    <!--      </d-collapse>-->
    <!--    </li>-->
    <li class="nav-item dropdown" v-click-outside="closeUserMenu">
      <a
        :class="['nav-link dropdown-toggle text-nowrap px-3', userMenuOpen ? 'account-menu-open' : '']"
        :data-testid="$testIds.nav.userMenu"
        @click="userMenuOpen = !userMenuOpen"
      >
        <div class="image-container">
          <ProfileImageState
            :id="`userAvatar${$store.state.auth.userData.avatarDocumentId}`"
            class="user-avatar profile-image-state--circle mr-2"
            :src="avatarSrc"
            :alt="$fullName($store.state.auth.userData.givenName, $store.state.auth.userData.familyName)"
            :name="$fullName($store.state.auth.userData.givenName, $store.state.auth.userData.familyName)"
            :title="$fullName($store.state.auth.userData.givenName, $store.state.auth.userData.familyName)"
          />
        </div>
        <span class="d-none d-md-inline-block">
          {{ $fullName($store.state.auth.userData.givenName, $store.state.auth.userData.familyName) }}
        </span>
      </a>
      <transition name="account-dropdown">
        <div
          v-show="userMenuOpen"
          id="user-actions"
          class="dropdown-menu dropdown-menu-small account-dropdown-menu"
        >
          <d-dropdown-item :to="{ name: 'personal-settings' }"
            ><i class="material-icons">&#xE7FD;</i>
            {{ $t("navBar.personalSettings") }}</d-dropdown-item
          >
          <d-dropdown-item :to="{ name: 'change-password' }"
            ><i class="material-icons">&#xE7FD;</i> {{ $t("navBar.changePassword") }}</d-dropdown-item
          >
          <d-dropdown-item v-if="permissionPaymentManagementComputed" :to="{ name: 'withdraw-confirmation' }"
            ><i class="material-icons">&#xE7FD;</i>
            {{ $t("navBar.withdrawalConfirmations") }}</d-dropdown-item
          >
          <!--        <d-dropdown-item><i class="material-icons">&#xE8B8;</i> Edit Profile</d-dropdown-item>-->
          <d-dropdown-divider />
          <d-dropdown-item :to="{ name: 'logout' }" class="text-danger" :data-testid="$testIds.nav.logout">
            <i class="material-icons text-danger">&#xE879;</i> {{ $t("navBar.logout") }}
          </d-dropdown-item>
        </div>
      </transition>
    </li>
  </d-navbar-nav>
</template>
<script>
import ProfileImageState from '@/components/ProfileImageState.vue';

export default {
  name: 'NavbarNav',
  components: { ProfileImageState },
  data() {
    return {
      userMenuOpen: false,
    };
  },
  beforeDestroy() {
    this.$eventHub.$off('toggle-sidebar');
  },
  computed: {
    avatarSrc() {
      const user = this.$store.state.auth.userData;
      return (user.avatarDocumentId && this.getProfileImage(user.avatarDocumentId))
        || user.avatarDocumentURL
        || '';
    },
    permissionPaymentManagementComputed() {
      return this.hasFeature('payments-management');
    },
  },
  methods: {
    closeUserMenu() {
      this.userMenuOpen = false;
    },
    getProfileImage(id) {
      return this.fetchCachedImage(id, () => this.$store.state.auth.userData
        && this.$store.state.auth.userData.avatarDocumentURL);
    },
  },
};
</script>
<style>
.nav-link:hover {
  cursor: pointer;
}

.dropdown-menu .dropdown-item {
  cursor: pointer;
}

.image-container {
  position: relative;
  display: inline-block;
}

</style>
